import z from "zod";
import {
  templateFormBaseSchema,
  templatePatientTypeSchema,
  templateScheduleSchema,
} from "./templateFormSchema";
import { weekdaySchema } from "@/api/Activities";

export const batchTemplateActivityInclusionTypeSchema = z.enum([
  "optional",
  "optionalWithDefaultSelected",
]);

export const batchTemplateActivityDelayedStartDateOptionsSchema = z.enum([
  "none",
  "offset",
  "weekday",
  "userSelects",
]);

export const batchTemplateActivityDelayedStartDateUnitSchema = z.enum([
  "week",
  "day",
]);

export const batchTemplateActivityTimeConfigTypeSchema = z.enum([
  "shared",
  "individual",
]);

export const batchTemplateActivityFormSchema = templateFormBaseSchema.extend({
  timeConfigType: batchTemplateActivityTimeConfigTypeSchema,
  inclusionType: batchTemplateActivityInclusionTypeSchema,
  delayedStartDate: batchTemplateActivityDelayedStartDateOptionsSchema,
  delayedStartDateOffset: z.string().nullish(),
  delayedStartDateUnit:
    batchTemplateActivityDelayedStartDateUnitSchema.nullish(),
  delayedStartDateWeekday: weekdaySchema.nullish(),
});

const batchTemplateActivitySchema = z
  .object({
    id: z.uuid(),
  })
  .extend(batchTemplateActivityFormSchema.shape);

export const batchTemplateFormSchema = z
  .object({
    title: z.string(),
    activities: z.array(batchTemplateActivitySchema),
    sharedTimeConfig: templateScheduleSchema.nullish(),
  })
  .extend(templatePatientTypeSchema.shape);

export type IBatchTemplateActivity = z.infer<
  typeof batchTemplateActivitySchema
>;
